export const ClinicianGroupType = {
  Active: 0,
  Inactive: 1,
};

export const ClinicianGroupTypeOptions = Object.keys(ClinicianGroupType).map(key =>
  Object.create({ id: ClinicianGroupType[key], name: key }),
);
